import { render, staticRenderFns } from "./KeyValueEditor.vue?vue&type=template&id=10bbe303&"
import script from "./KeyValueEditor.vue?vue&type=script&lang=ts&"
export * from "./KeyValueEditor.vue?vue&type=script&lang=ts&"
import style0 from "./KeyValueEditor.vue?vue&type=style&index=0&id=10bbe303&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports